import { ActionContext } from 'vuex';
import type { SelectionState } from './mutations';

type RootGetters = Record<string, any>;
type Ctx = ActionContext<SelectionState, any> & { rootGetters: RootGetters };

export default {
  setHome({ commit }: Ctx, homeId: string | null){
    commit('setSelectedHomeId', homeId);
  },
  setRoom({ commit }: Ctx, roomId: string | null){
    commit('setSelectedRoomId', roomId);
  },
  setDevice({ commit }: Ctx, deviceId: string | null){
    commit('setSelectedDeviceId', deviceId);
  },
  setGateway({ commit }: Ctx, gatewayId: string | null){
    commit('setSelectedGatewayId', gatewayId);
  },

  selectDeviceWithContext({ commit, rootGetters }: Ctx, deviceId: string){
    commit('setSelectedDeviceId', deviceId);

    const relationships = rootGetters['catalog/relationships'] || rootGetters['catalog/relationships'];
    if(!relationships){
      console.warn('[Selection] Relationships not available yet');
      return;
    }

    const gatewayId = relationships.deviceToGateway[deviceId];
    if(gatewayId){
      commit('setSelectedGatewayId', gatewayId);
    }

    const roomId = relationships.deviceToRoom[deviceId];
    if(roomId){
      commit('setSelectedRoomId', roomId);
    }

    const homeId = relationships.deviceToHome[deviceId];
    if(homeId){
      commit('setSelectedHomeId', homeId);
    }
  },

  reset({ commit }: Ctx){
    commit('reset');
  },

  cachePhotoUrl({ commit }: Ctx, { homeUid, photoUrl }: { homeUid: string; photoUrl: string }){
    commit('setPhotoUrlForHome', { homeUid, photoUrl });
  },
  cacheRooms({ commit }: Ctx, { homeUid, rooms }: { homeUid: string; rooms: any[] }){
    commit('setRoomsForHome', { homeUid, rooms });
  },
};


